var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCautionvalidation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8661 2.99996L22.3921 19.5C22.4799 19.652 22.5261 19.8244 22.5261 20C22.5261 20.1755 22.4799 20.3479 22.3921 20.4999C22.3043 20.652 22.1781 20.7782 22.0261 20.866C21.8741 20.9537 21.7016 21 21.5261 21H2.4741C2.29856 21 2.12612 20.9537 1.9741 20.866C1.82209 20.7782 1.69585 20.652 1.60809 20.4999C1.52032 20.3479 1.47412 20.1755 1.47412 20C1.47412 19.8244 1.52033 19.652 1.6081 19.5L11.1341 2.99996C11.2219 2.84795 11.3481 2.72172 11.5001 2.63396C11.6521 2.5462 11.8246 2.5 12.0001 2.5C12.1756 2.5 12.3481 2.5462 12.5001 2.63396C12.6521 2.72172 12.7783 2.84795 12.8661 2.99996ZM11.0001 16V18H13.0001V16H11.0001ZM11.0001 8.99996V14H13.0001V8.99996H11.0001Z",
    fill: "#F37C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionvalidation);
export default __webpack_public_path__ + "static/media/cautionvalidation.4d975082c13f1f97434291e09107c577.svg";
export { ForwardRef as ReactComponent };